import { getPageData } from '@realestate.com.au/iglu-data';
import tealiumWrapper from '../../../shared/tracking/tealium/tealiumWrapper';
import { constructUserData } from '../../../shared/tracking/tealium/trackingUtils';
import {
  TEALIUM_SITE,
  PAGE_TYPE_HOME_PAGE,
  TEALIUM_SCHEMA_IN_PAGE_NAVIGATION,
  TEALIUM_SCHEMA_NEARBY_LOCATION_SELECTED,
} from '../../../shared/tracking/tealium/constants';
import { setTrackingSource } from '../../../client/tracking/tealium/sourceTracking';

const buildPageSubSection = channel => `${TEALIUM_SITE}:${channel.tealium}:${PAGE_TYPE_HOME_PAGE}`;

const trackPageEvent = ({ channelObject }) => {
  const pageData = getPageData({
    site: TEALIUM_SITE,
    pageType: PAGE_TYPE_HOME_PAGE,
    siteSection: channelObject.tealium,
    siteSubSection: buildPageSubSection(channelObject),
  });

  tealiumWrapper.trackView([pageData, constructUserData]);
};

const searchAreaUserAction = ({ userAction }) => {
  tealiumWrapper.trackEvent(() => ({
    schema: TEALIUM_SCHEMA_NEARBY_LOCATION_SELECTED,
    data: {
      event_name: 'nearby_location_selected',
      user_action: userAction,
    },
  }));
};

const trackAreaAndRegionSelectorClick = ({ areaId, regionId }) => {
  const normalisedAreaId = areaId.toLowerCase();
  const areaAndRegion = regionId === 'any' ? normalisedAreaId : `${normalisedAreaId}-${regionId}`;
  tealiumWrapper.trackEvent(() => ({
    schema: TEALIUM_SCHEMA_IN_PAGE_NAVIGATION,
    data: {
      event_name: 'in_page_navigation',
      user_action: `area_selector_click:${areaAndRegion}`,
    },
  }));
};

const trackRecentSearchClick = ({ channelObject }) => {
  const page = buildPageSubSection(channelObject);
  setTrackingSource({ page, element: 'recent search click' });
};

const trackAreaItemClick = ({ channelObject, itemId }) => {
  setTrackingSource({
    page: buildPageSubSection(channelObject),
    element: `area_click:${itemId}`,
  });
};

const trackPropertyTypeClick = ({ channelObject }) => {
  const page = buildPageSubSection(channelObject);
  setTrackingSource({ page, element: 'property_type_tile' });
};

export {
  buildPageSubSection,
  trackPageEvent,
  trackAreaAndRegionSelectorClick,
  searchAreaUserAction,
  trackRecentSearchClick,
  trackAreaItemClick,
  trackPropertyTypeClick,
};
